import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ToolbarNotificationsDropdownComponent } from './toolbar-notifications/toolbar-notifications-dropdown/toolbar-notifications-dropdown.component';
import { ToolbarNotificationsComponent } from './toolbar-notifications/toolbar-notifications.component';
import { ToolbarSearchComponent } from './toolbar-search/toolbar-search.component';
import { ToolbarUserComponent } from './toolbar-user/toolbar-user.component';
import { ToolbarComponent } from './ui-toolbar/toolbar.component';

import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SharedFeatureBreadcrumbsModule } from '@nx-ratenow/shared/feature-breadcrumbs';
import { SharedPipesModule } from '@nx-ratenow/shared/pipes';
import { NotificationsFacade } from './+state/notifications/notifications.facade';
import { AppsMenuComponent } from './apps-menu/apps-menu.component';

@NgModule({
  imports: [
    CommonModule,
    SharedFeatureBreadcrumbsModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatRippleModule,
    MatFormFieldModule,
    MatBadgeModule,
    MatTabsModule,
    MatTooltipModule,
    MatSelectModule,

    RouterModule,
    SharedPipesModule,
    MatInputModule,
    TranslateModule
  ],
  declarations: [
    ToolbarNotificationsDropdownComponent,
    ToolbarNotificationsComponent,

    ToolbarSearchComponent,

    ToolbarUserComponent,

    ToolbarComponent,

    AppsMenuComponent
  ],
  exports: [ToolbarUserComponent, ToolbarSearchComponent, ToolbarNotificationsComponent, ToolbarComponent],
  providers: [NotificationsFacade]
})
export class CoreLayoutFeatureToolbarModule {}
